import React from 'react';
import moment from 'moment';
import intl from 'react-intl-universal';

/**
 * Format the given date.
 */
interface FormatDateProps {
  value?: string | number | Date | null;
  format?: string;
}

export function FormatDate({
  value,
  format = 'YYYY MMM DD',
}: FormatDateProps): JSX.Element {
  if (value == null || value === '') return <></>;
  const parsed = moment(value);
  if (!parsed.isValid()) return <></>;
  const localizedFormat = intl.get(`date_formats.${format}`) || format;
  return <>{parsed.format(localizedFormat)}</>;
}

/**
 * Format date table cell.
 */
interface FormatDateCellProps {
  value?: string | number | Date | null;
  column: { formatDate?: Partial<FormatDateProps> };
}

export function FormatDateCell({
  value,
  column: { formatDate },
}: FormatDateCellProps) {
  return <FormatDate value={value} {...formatDate} />;
}
